module.exports = __webpack_public_path__ + "img/mumei_n.effcf7be.png";